module.exports = __webpack_public_path__ + "static/img/none-coupon.40a3c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coupon/none-coupon.png
// module id = K0KN
// module chunks = 4